import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';

import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SubmenuComponent } from './sidebar/components/submenu/submenu.component';

import { ImagenProfilePipe } from './navbar/imagen-profile.pipe';
import { IsObjectPipe } from '../pipes/is-object-pipe';

import { FiltrosBitacoraComponent } from './filtros-bitacora/filtros-bitacora.component';

@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    SidebarComponent,
    SubmenuComponent,
    ImagenProfilePipe,
    IsObjectPipe,
    FiltrosBitacoraComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CollapseModule.forRoot(),
    PerfectScrollbarModule,
    BsDropdownModule.forRoot()
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    SidebarComponent,
    SubmenuComponent,
    ImagenProfilePipe,
    FiltrosBitacoraComponent
  ]
})
export class ComponentsModule {}